import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import shoppingCartSlice from '../modules/ShoppingCart/ShoppingCartSlice';
import packageDataSlice from '../modules/PackageDetails/packageDataSlice';
import searchSlice from '../modules/SearchDatePicker/searchDatePickerSlice';
import configSlice from './config';
import hotelSlice from '../modules/HotelDetails/hotelSlice';
import flightSlice from '../modules/FlightDetails/flightSlice';
import eventSlice from '../modules/SportsAndEventsPage/eventsSlice';
import ShoppingCartSliceV2 from '../modules/ShoppingCart/ShoppingCartSliceV2';
import dynamicPageConfigReducer from './dynamicPageConfigSlice';
import flightAsyncSlice from './flightAsync/flightAsyncSlice';
import flightDynamicAsyncSlice from './flightAsync/flightDynamicAsyncSlice';

const reducer = combineReducers({
  search: searchSlice,
  config: configSlice,
  package: packageDataSlice,
  shoppingCart: shoppingCartSlice,
  shoppingCartV2: ShoppingCartSliceV2,
  hotels: hotelSlice,
  flights: flightSlice,
  events: eventSlice,
  flightAsync: flightAsyncSlice,
  flightDynamicAsync: flightDynamicAsyncSlice,
  dynamicPageConfig: dynamicPageConfigReducer
});

export const store = configureStore({
  reducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;